<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.CardReturn.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.CardReturn.msg2') }}</div>
        <!-- <div class="lyr-txt">반납하실 거스름돈을 꼭 확인해주세요.</div> -->
      </div>
      <div class="layer__body">
        <img :src="cardReturnImgSrc" alt="" class="img-size" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'cardReturn',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      cardReturnImgSrc: '',
    };
  },
  mounted() {
    if (this.$i18n.locale == 'jp') {
      this.cardReturnImgSrc = require('@/assets/images/user/artwork_popup_card_out_3d_jp.gif');
    } else {
      this.cardReturnImgSrc = require('@/assets/images/user/artwork_popup_card_out_3d_ko.gif');
    }
  },
  props: {
    totalUprc: Number,
  },
  methods: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
